export const availableLocales = [
  "ar",
  "bg",
  "cs",
  "cy-GB",
  "da",
  "de",
  "el",
  "en-GB",
  "en-US",
  "es-ES",
  "et-EE",
  "fa",
  "fi",
  "fr",
  "ga-IE",
  "hr-HR",
  "hu",
  "id",
  "is-IS",
  "it",
  "ja",
  "ko",
  "lt-LT",
  "lv-LV",
  "mk-MK",
  "mt-MT",
  "nl",
  "no",
  "pl",
  "pt-BR",
  "pt-PT",
  "ro",
  "ro-RO",
  "ru",
  "sk",
  "sl-SI",
  "sr-SP",
  "sv",
  "tr",
  "vi",
  "zh-CN",
] as const;

export type LocaleId = (typeof availableLocales)[number];

export function isLocaleId(x: string): x is LocaleId {
  return availableLocales.includes(x as LocaleId);
}
